module.exports = __webpack_public_path__ + "static/media/coming_soon.ebb5892d.png";